import { Box } from '@octano/global-ui';

export function BoxMultiple({
  content,
}: {
  content: { title: string; body: string }[];
}) {
  return (
    <Box
      color="primary"
      variant="outlined"
      style={{ borderRadius: 4 }}
      className={`py-2 px-3`}
      body={
        <div className="d-flex justify-content-between">
          {content.map((item, index) => (
            <Box
              key={index}
              color="primary"
              variant="outlined"
              className="p-0 border-0 text-uppercase"
              title={item.title}
              body={
                <p className="fs-14 mb-0 pr-2 text-capitalize">{item.body}</p>
              }
            />
          ))}
        </div>
      }
    />
  );
}
